// assets/component-side-timeline.js
(() => {
  if (window.__stl_inited) return;
  window.__stl_inited = true;

  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  function headerOffset(explicit) {
    const n = parseInt(explicit || '0', 10);
    if (Number.isFinite(n) && n > 0) return n;
    // Авто: пробуємо sticky-header Dawn
    const sticky = document.querySelector('sticky-header') || document.querySelector('header.header');
    return sticky ? sticky.getBoundingClientRect().height : 0;
  }

  function smoothScrollToEl(el, offset=0) {
    const y = window.scrollY + el.getBoundingClientRect().top - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function init(nav) {
    const offset = headerOffset(nav.dataset.offset);
    const items  = $$('.stl__item', nav);
    if (!items.length) return;

    // Плавний скрол по кліку
    nav.addEventListener('click', (e) => {
      const a = e.target.closest('a.stl__btn[href^="#"]');
      if (!a || !nav.contains(a)) return;
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      smoothScrollToEl(el, offset);
      history.replaceState(null, '', `#${id}`);
    });

    // Highlight активної секції
    const io = new IntersectionObserver((entries) => {
      const seen = entries
        .filter(en => en.isIntersecting)
        .sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!seen) return;
      const activeId = seen.target.id;
      items.forEach(li => li.classList.toggle('is-active', li.dataset.id === activeId));
    }, { rootMargin: `-${offset + 10}px 0px -60% 0px`, threshold: [0, 0.3, 0.6] });

    items.forEach(li => {
      const el = document.getElementById(li.dataset.id);
      if (el) io.observe(el);
    });

    // Опційно: замінити лейбли з data-timeline-label/h1..h4
    items.forEach(li => {
      const el = document.getElementById(li.dataset.id);
      if (!el) return;
      const dataLabel = el.getAttribute('data-timeline-label');
      const heading = el.querySelector('h1,h2,h3,h4');
      const span = li.querySelector('.stl__label');
    
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    $$('.stl').forEach(init);
  });
})();
